<style lang="less" scoped>
.query-title-div {
  width: 90px !important;
}
.list-content-div {
  margin-top: 16px;
}
</style>

<template>
  <div class="detail-container">
    <div class="detail-bread-crumb-div">
      <ZD-bread-crumb :bConfigList="pageConfig.detailBreadCrumb"></ZD-bread-crumb>
    </div>
    <div class="detail-content-div">
      <div class="detail-content-header-div flex">
        <div class="left-page-title-div flex-1">充电记录详情</div>
      </div>
      <div class="list-content-div">
        <ZD-list-querys>
          <template slot="inputs">
            <div class="list-query-child-div flex">
              <div class="query-title-div">用户手机号</div>
              <div class="query-inputs-div flex-1">
                <el-input size="small" v-model="queryInfo.custPhone" placeholder="请输入内容" clearable
                  @keyup.enter.native="getListData(pagination, true)"></el-input>
              </div>
            </div>
            <div class="list-query-child-div flex">
              <div class="query-title-div">订单编号</div>
              <div class="query-inputs-div flex-1">
                <el-input size="small" v-model="queryInfo.orderNo" placeholder="请输入内容" clearable
                  @keyup.enter.native="getListData(pagination, true)"></el-input>
              </div>
            </div>
            <div class="list-query-child-div flex">
              <div class="query-title-div">充电日期</div>
              <div class="query-inputs-div flex-1">
                <el-date-picker size="small" v-model="time" type="datetimerange" style="width: 100%;"
                  value-format="yyyy-MM-dd HH:mm:ss" range-separator="-"
                  start-placeholder="开始日期" end-placeholder="结束日期" @change="handleTimeChange"></el-date-picker>
              </div>
            </div>
            <div class="list-query-child-div flex">
              <div class="query-title-div">订单类型</div>
              <div class="query-inputs-div flex-1">
                <el-select class="full-width" size="small" v-model="queryInfo.source" clearable>
                  <el-option v-for="item in orderNoList" :key="item.configVal" :label="item.configName" :value="item.configVal"></el-option>
                </el-select>
              </div>
            </div>
            <div class="list-query-child-div flex">
              <div class="query-title-div">订单属性</div>
              <div class="query-inputs-div flex-1">
                <el-select class="full-width" size="small" v-model="queryInfo.orderProperty" clearable>
                  <el-option label="正常" value="01"></el-option>
                  <el-option label="异常" value="02"></el-option>
                </el-select>
              </div>
            </div>
            <div class="list-query-child-div flex">
              <div class="query-title-div">账号类型</div>
              <div class="query-inputs-div flex-1">
                <el-select class="full-width" size="small" v-model="queryInfo.orderProperty" clearable>
                  <el-option label="主账号" value="01"></el-option>
                  <el-option label="亲友账号" value="02"></el-option>
                </el-select>
              </div>
            </div>
          </template>
          <template slot="actions">
            <button class="common-bg-button" @click="getListData(pagination, true)">搜 索</button>
            <button class="common-empty-button" @click="reset()">重 置</button>
          </template>
        </ZD-list-querys>
        <!-- 表格 -->
        <div class="list-table">
          <ZD-table :tableColumns="pageConfig.chargeRecordColumns" :operates="operates" :tableData="tableData"
            :tableConfig="pageConfig.tableConfig" :selections="selections"
            v-on:updateSelections="(sels) => { selections = sels } "></ZD-table>
        </div>
        <!-- 分页 -->
        <div class="list-pagination">
          <ZD-pagination :pagination="pagination" v-on:pageUpdate="getListData"></ZD-pagination>
        </div>
      </div>
    </div>

    <el-dialog title="查看折线图" :visible.sync="dialogVisible.show" width="60%">
      <div id="myChart" :style="{ width: '100%', height: '320px' }">></div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible.show = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible.show = false">确 定</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
  import pageConfig from './page-config'
  export default {
    data() {
      return {
        pageConfig,
        pagination: pageConfig.pagination,
        // 默认值设置
        detailForm: {},
        queryInfo: {},
        pileGunNum: '',
        pileStatusEntity: {},
        operates: {
          width: 220,
          fixed: 'right',
          list: [
            {
              id: 'charge',
              label: '查看折线图',
              type: 'primary',
              show: true,
              disabled: false,
              method: (index, row) => {
                this.openEchart(row)
              },
            },
          ],
        }, // 列操作按钮
        time: [], //充电日期
        tableData: [], // 表格数据
        selections: [], // 表格选项
        orderNoList: [], // 订单类型
        dialogVisible: {
          show: false,
          myChart: '',
        }
      }
    },
    mounted() {
      this.init()

    },
    methods: {
      init() {
        let _ = this
        _.queryInfo.pileCode = _.$store.state.editId
        _.getSelectData()
        _.getListData(_.pagination, true)
      },
      // 获取表格数据
      getListData(pagination, reload = false) {
        let _ = this
        _.$U.showLoading(_)
        _.queryInfo.pageNum = pagination.current - 1
        if (reload) {
          _.queryInfo.pageNum = 0
        }
        _.queryInfo.pageSize = pagination.pageSize
        _.$H.get(_, _.$A.pile.pileorder, _.queryInfo).then((res) => {
          _.tableData = res.data.data.content || []
          _.pagination.total = res.data.data.totalElements || 0;
          _.$U.hideLoading(_)
        })
      },
      getSelectData(){
        let _ = this;
        // 订单类型
        _.$H.post(_, _.$A.config.list, { configType: '154' }).then((res) => {
          _.orderNoList = res.data.data
        })
      },

      openEchart(row){
        let _ = this;
        if(row.chargeStepCode === '02'){
          let params = {
            beginTime: row.beginTime,
            endTime: row.endTime,
            pileCode: row.pileCode,
          }
          _.$H.post(_, _.$A.digitization.pileAreaDataList, params).then(res => {

            console.log(res.data.data)
            _.dialogVisible.show = true;

            _.$nextTick(() => {
              _.handleShowLineCharts(res.data.data)
            })
          })
        }else {
          _.$U.error("当前充电桩订单正在充电中,请稍侯！")
        }

      },
      // 查看折线图
      handleShowLineCharts(row){
        let _ = this;
        // echarts 初始化
        _.dialogVisible.myChart = _.$echarts.init(document.getElementById('myChart'));
        let resizeDiv = document.getElementById('myChart');
        resizeDiv.removeAttribute('_echarts_instance_');

        let dateArr = []
        let pressureUa = []
        let pressureUb = []
        let pressureUc = []
        let currentLa = []
        let currentLb = []
        let currentLc = []
        row.forEach( li => {
          dateArr.push(li.createdWhen)

          pressureUa.push( (Number(li.pressureUa) + Number(li.pressureUb) + Number(li.pressureUc)).toFixed(3))
          currentLa.push( (Number(li.currentLa) + Number(li.currentLb) + Number(li.currentLc)).toFixed(3))

          // pressureUa.push(li.pressureUa)
          // pressureUb.push(li.pressureUb)
          // pressureUc.push(li.pressureUc)
          // currentLa.push(li.currentLa)
          // currentLb.push(li.currentLb)
          // currentLc.push(li.currentLc)
        })

        let options = {

          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'cross',
              label: {
                backgroundColor: '#6a7985'
              }
            }
          },
          legend: {
            // data: ['A相电压', 'B相电压', 'C相电压', 'A相电流', 'B相电流', 'C相电流']
            data: ['电流', '电压']
          },
          color: [ '#8bdeff', '#ff6d6d'],
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          xAxis: [
            {
              type: 'category',
              boundaryGap: false,
              data: dateArr || []
            }
          ],
          yAxis: [
            {
              type: 'value'
            }
          ],
          series: [
            {
              name: '电流',
              type: 'line',
              stack: 'Total',
              areaStyle: {
                color: '#8bdeff'
              },
              emphasis: {
                focus: 'series'
              },
              data: currentLa || []
            },
            {
              name: '电压',
              type: 'line',
              stack: 'Total',
              areaStyle: {
                color: '#ff6d6d'
              },
              emphasis: {
                focus: 'series'
              },
              data: pressureUa || []
            },


            // {
            //   name: 'B相电压',
            //   type: 'line',
            //   stack: 'Total',
            //   areaStyle: {
            //     color: '#ff6d6d'
            //   },
            //   emphasis: {
            //     focus: 'series'
            //   },
            //   data: pressureUb || []
            // },
            // {
            //   name: 'C相电压',
            //   type: 'line',
            //   stack: 'Total',
            //   areaStyle: {
            //     color: '#8bdeff'
            //   },
            //   emphasis: {
            //     focus: 'series'
            //   },
            //   data: pressureUc || []
            // },

            // {
            //   name: 'B相电流',
            //   type: 'line',
            //   stack: 'Total',
            //   areaStyle: {
            //     color: '#8bdeff'
            //   },
            //   emphasis: {
            //     focus: 'series'
            //   },
            //   data: currentLb || []
            // },
            // {
            //   name: 'C相电流',
            //   type: 'line',
            //   stack: 'Total',
            //   areaStyle: {
            //     color: '#8bdeff'
            //   },
            //   emphasis: {
            //     focus: 'series'
            //   },
            //   data: currentLc || []
            // },

          ]
        }

        // 绘制图表
        _.dialogVisible.myChart.setOption(options);

        window.addEventListener("resize", function () {
          _.dialogVisible.myChart.resize();
        });

      },
      //选择充电日期
      handleTimeChange(val) {
        if (val) {
          this.queryInfo.dtFrom = val[0]
          this.queryInfo.dtTo = val[1]
        } else {
          delete this.queryInfo.dtFrom
          delete this.queryInfo.dtTo
        }
      },
      //重置
      reset() {
        delete this.queryInfo.dtFrom
        delete this.queryInfo.dtTo
        delete this.queryInfo.custPhone
        delete this.queryInfo.orderNo
        delete this.queryInfo.source
        delete this.queryInfo.orderProperty
        this.time = []
        this.getListData(this.pagination)
      },
    },

  }
</script>
